import { FC } from 'react';
import styled from 'styled-components';
import {
  UploadedFile,
  chatActions,
  useAppDispatch,
} from '@vs-online-only-app/state';
import { MediaCard, MediaType, PreviewSize } from '@vs-online-only-app/ui';

type Props = {
  conversationId: string;
  files: UploadedFile[];
};

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 80px);
  grid-auto-rows: 80px;
  grid-gap: 8px;
`;

const MessageComposerUploadedFiles: FC<Props> = ({ conversationId, files }) => {
  const dispatch = useAppDispatch();

  return (
    <Wrapper>
      {files.map((file) => {
        const mediaType = file.type.includes('video')
          ? MediaType.Video
          : MediaType.Image;
        return (
          <MediaCard
            size={PreviewSize.Small}
            url={file.url}
            mediaType={mediaType}
            borderColor="primary"
            showVideoDuration
            handleRemove={() =>
              dispatch(
                chatActions.removeConversationUploadedFile({
                  conversationId,
                  fileUrl: file.url,
                })
              )
            }
          />
        );
      })}
    </Wrapper>
  );
};

export default MessageComposerUploadedFiles;
